__turbopack_context__.v({
  "animTextContent": "ProductWizard-module__t6bP-G__animTextContent",
  "desktopBr": "ProductWizard-module__t6bP-G__desktopBr",
  "root": "ProductWizard-module__t6bP-G__root",
  "stickyWrapper": "ProductWizard-module__t6bP-G__stickyWrapper",
  "tc1": "ProductWizard-module__t6bP-G__tc1",
  "tc2": "ProductWizard-module__t6bP-G__tc2",
});
